import * as Yup from 'yup';

const validationSchema = () => {
  return Yup.object({
    name: Yup.string().required('nameInput.validationError.fieldRequired'), // t('nameInput.validationError.fieldRequired') <- for i18n-unused
    email: Yup.string()
      // .email() - default email validation doesn't work properly
      .matches(
        /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        'emailAddressInput.validationError.emailNotValid'
      )
      .required('emailAddressInput.validationError.fieldRequired'), // t('emailAddressInput.validationError.fieldRequired') t('emailAddressInput.validationError.emailNotValid') <- for i18n-unused
    password: Yup.string()
      .required('passwordInput.validationError.fieldEmpty')
      .min(6, 'passwordInput.validationError.passwordMinLength'), // t('passwordInput.validationError.fieldEmpty') t('passwordInput.validationError.passwordMinLength') <- for i18n-unused
    accessCode: Yup.string().required('accessCodeInput.validationError.fieldRequired'), // t('accessCodeInput.validationError.fieldRequired') <- for i18n-unused
    agreementsTermsAndConditions: Yup.boolean().oneOf(
      [true],
      'app.signUp.termsAccept.validationError'
    ), // t('app.signUp.termsAccept.validationError') <- for i18n-unused
  });
};

const validationSchema2 = () => {
  return Yup.object({
    name: Yup.string().required('nameInput.validationError.fieldRequired'), // t('nameInput.validationError.fieldRequired') <- for i18n-unused
    email: Yup.string()
      // .email() - default email validation doesn't work properly
      .matches(
        /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        'emailAddressInput.validationError.emailNotValid'
      )
      .required('emailAddressInput.validationError.fieldRequired'), // t('emailAddressInput.validationError.fieldRequired') t('emailAddressInput.validationError.emailNotValid') <- for i18n-unused
    password: Yup.string()
      .required('passwordInput.validationError.fieldEmpty')
      .min(6, 'passwordInput.validationError.passwordMinLength'), // t('passwordInput.validationError.fieldEmpty') t('passwordInput.validationError.passwordMinLength') <- for i18n-unused
    accessCode: Yup.string().required('accessCodeInput.validationError.fieldRequired'), // t('accessCodeInput.validationError.fieldRequired') <- for i18n-unused
    agreementsTermsAndConditions: Yup.boolean().oneOf(
      [true],
      'app.signUp.termsAccept.validationError'
    ), // t('app.signUp.termsAccept.validationError') <- for i18n-unused
    agreementsPersonalDataProcessing: Yup.boolean().oneOf(
      [true],
      'validation/accept-condition/required'
    ), // t('validation/accept-condition/required') <- for i18n-unused
  });
};

export { validationSchema, validationSchema2 };
